import { render, staticRenderFns } from "./LklWithdral.vue?vue&type=template&id=60de90b1&scoped=true&"
import script from "./LklWithdral.vue?vue&type=script&lang=js&"
export * from "./LklWithdral.vue?vue&type=script&lang=js&"
import style0 from "./LklWithdral.vue?vue&type=style&index=0&id=60de90b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de90b1",
  null
  
)

export default component.exports